import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: '/',
  routes: [{
    path: '/',
    component: resolve => require(['../components/Home.vue'], resolve),
    name: '首页',
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/aboutus',
    component: resolve => require(['../components/Aboutus.vue'], resolve),
    name: '关于我们',
    redirect: '/aboutus/intro',
    children: [{
      path: 'intro',
      component: resolve => require(['../components/Aboutus/intro.vue'], resolve),
      name: '公司介绍',
      meta: {
        typeid: 31,
        keepAlive: true,
        zhTitle: '公司介绍',
        enTitle: 'COMPANY INTRODUCTION'
      }
    },
    {
      path: 'speech',
      component: resolve => require(['../components/Aboutus/speech.vue'], resolve),
      name: '董事长致辞',
      meta: {
        typeid: 32,
        keepAlive: true,
        zhTitle: '董事长致辞',
        enTitle: 'CHAIRMAN\'S SPEECH'
      }
    },
    {
      path: 'culture',
      component: resolve => require(['../components/Aboutus/culture.vue'], resolve),
      name: '企业文化',
      meta: {
        typeid: 33,
        keepAlive: true,
        zhTitle: '企业文化',
        enTitle: 'CORPORATE CULTURE'
      }
    },
    {
      path: 'qualification',
      component: resolve => require(['../components/Aboutus/qualification.vue'], resolve),
      name: '企业资质',
      meta: {
        keepAlive: true,
        zhTitle: '企业资质',
        enTitle: 'COMPANY INTRODUCTION'
      }
    },
    {
      path: 'bigevent',
      component: resolve => require(['../components/Aboutus/bigevent.vue'], resolve),
      name: '大事件',
      meta: {
        keepAlive: true,
        zhTitle: '大事记',
        enTitle: 'CHRONICLE OF EVENTS'
      }
    },
    {
      path: 'videos',
      component: resolve => require(['../components/Aboutus/videos.vue'], resolve),
      name: '视频展示',
      meta: {
        keepAlive: true,
        zhTitle: '视频展示',
        enTitle: 'COMPANY INTRODUCTION'
      }
    }
    ]
  },
  {
    path: '/news',
    component: resolve => require(['../components/News.vue'], resolve),
    name: '新闻动态',
    redirect: '/news/company',
    children: [{
      path: 'company',
      component: resolve => require(['../components/assembly/newstemplate.vue'], resolve),
      name: '公司新闻',
      meta: {
        typeid: 15,
        keepAlive: true,
        zhTitle: '公司新闻',
        enTitle: 'COMPANY NEWS'
      }
    },
    {
      path: 'industry',
      component: resolve => require(['../components/assembly/newstemplate.vue'], resolve),
      name: '行业动态',
      meta: {
        typeid: 14,
        keepAlive: true,
        zhTitle: '行业动态',
        enTitle: 'INDUSTRY DYNAMICS'
      }
    }
    ]
  },
  {
    path: '/newsDetail/:id',
    component: resolve => require(['../components/NewsDetail.vue'], resolve),
    name: 'NewsDetail',
    meta: {
      keepAlive: true
    }
  },
  {
    path: '/productCenter',
    component: resolve => require(['../components/ProductCenter.vue'], resolve),
    name: '产品中心',
    meta: {
      keepAlive: true,
      zhTitle: '产品中心',
      enTitle: 'PRODUCT CENTER'
    }
  },
  {
    path: '/searchCenter',
    component: resolve => require(['../components/searchCenter.vue'], resolve),
    name: 'searchCenter',
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/productDetail/:id',
    component: resolve => require(['../components/ProductDetail.vue'], resolve),
    name: 'ProductDetail',
    meta: {
      keepAlive: false
    }
  },
  {
    path: '/serviceCooperation',
    component: resolve => require(['../components/ServiceCooperation.vue'], resolve),
    name: '服务与合作',
    redirect: '/serviceCooperation/problem',
    children: [{
      path: 'problem',
      component: resolve => require(['../components/service/problem.vue'], resolve),
      name: '常见问题',
      meta: {
        typeid: 48,
        keepAlive: true,
        zhTitle: '常见问题',
        enTitle: 'CHAIRMAN\'S SPEECH'
      }
    },
    {
      path: 'policy',
      component: resolve => require(['../components/service/policy.vue'], resolve),
      name: '维修政策',
      meta: {
        typeid: 49,
        keepAlive: true,
        zhTitle: '维修政策',
        enTitle: 'CHAIRMAN\'S SPEECH'
      }
    }
    ]
  },
  {
    path: '/relationship',
    component: resolve => require(['../components/Relationship.vue'], resolve),
    name: '投资者关系',
    redirect: '/relationship/notice',
    children: [{
      path: 'notice',
      component: resolve => require(['../components/assembly/newstemplate.vue'], resolve),
      name: '公司公告',
      meta: {
        typeid: 18,
        keepAlive: true,
        zhTitle: '公司公告',
        enTitle: 'COMPANY ANNOUNCEMENT'
      }
    },
    {
      path: 'members',
      component: resolve => require(['../components/Relationship/members.vue'], resolve),
      name: '董事会成员',
      meta: {
        keepAlive: true,
        zhTitle: '董事会成员',
        enTitle: 'CHAIRMAN\'S SPEECH'
      }
    }
    ]
  },
  {
    path: '/contactus',
    component: resolve => require(['../components/Contactus.vue'], resolve),
    name: '联系我们',
    redirect: '/contactus/presale',
    children: [{
      path: 'presale',
      component: resolve => require(['../components/assembly/articletemplate.vue'], resolve),
      name: '售前咨询',
      meta: {
        typeid: 50,
        keepAlive: true,
        zhTitle: '售前咨询',
        enTitle: 'CHAIRMAN\'S SPEECH'
      }
    },
    {
      path: 'aftersales',
      component: resolve => require(['../components/assembly/articletemplate.vue'], resolve),
      name: '售后支持',
      meta: {
        typeid: 51,
        keepAlive: true,
        zhTitle: '售后支持',
        enTitle: 'CHAIRMAN\'S SPEECH'
      }
    },
    {
      path: 'message',
      component: resolve => require(['../components/Contactus/message.vue'], resolve),
      name: '在线留言',
      meta: {
        keepAlive: true,
        zhTitle: '在线留言',
        enTitle: 'ONLINE MESSAGE'
      }
    }
    ]
  },
  {
    path: '*',
    component: resolve => require(['../components/Home.vue'], resolve),
    name: '首页',
    meta: {
      keepAlive: true
    }
    // component: () => import('../components/404'),
    // name: 'error',
    // meta: {
    //   keepAlive: false
    // }
  }
  ],
  scrollBehavior (to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
    // if (savedPosition) {
    //   return savedPosition
    // } else {
    //   return { x: 0, y: 0 }
    // }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js